var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c(
          "section",
          { staticClass: "d-webview-none" },
          [
            _vm.pageDTO.selectedDeviceDTO
              ? _c("selected-device", {
                  staticClass: "d-flex flex-column align-items-md-start mt-1",
                  attrs: {
                    title: _vm.pageDTO.selectedDeviceDTO.title,
                    text: _vm.pageDTO.selectedDeviceDTO.text,
                    "complementary-text":
                      _vm.pageDTO.selectedDeviceDTO.complementaryText,
                    "modify-button": _vm.pageDTO.selectedDeviceDTO.modifyButton,
                    "delete-button": _vm.pageDTO.selectedDeviceDTO.deleteButton,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("offer", {
          attrs: {
            offer: _vm.currentOffer,
            "blocked-or-not-label": _vm.labels.blockedOrNot,
            "new-client-label": _vm.labels.newClient,
            "already-client-label": _vm.labels.alreadyClient,
            "advantage-messages": _vm.pageDTO.advantageMessages,
            "info-options": _vm.pageDTO.infoOptions,
            "is-online-recovery-available": _vm.pageDTO.onlineRecoveryAvailable,
          },
        }),
        _vm._v(" "),
        _vm.currentOffer.pushZigZagDTO
          ? _c(
              "div",
              [
                _c("push-zig-zag", {
                  attrs: { zigzag: _vm.currentOffer.pushZigZagDTO },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentOffer.withBlockedOfferToggle
          ? _c("div", [
              _vm.currentOffer.hasBlockedVersion
                ? _c(
                    "div",
                    {
                      staticClass: "row",
                      class: _vm.currentOffer.blocked ? "" : "pb-1",
                      attrs: { id: "version-blocked-selection" },
                    },
                    [
                      _c("div", { staticClass: "col-12 lead py-1" }, [
                        _c("strong", [
                          _vm._v(" " + _vm._s(_vm.labels.selectVersion) + " "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "col-12",
                          attrs: { autocomplete: "off" },
                        },
                        [
                          _c("ob1-radio-button-list", {
                            attrs: {
                              "with-box": true,
                              "radios-buttons":
                                _vm.pageDTO.radioButtonCardDTO.radioButtonList,
                            },
                            on: { change: _vm.onVersionChange },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentOffer.blocked
                ? _c(
                    "div",
                    { staticClass: "row", attrs: { id: "messageBlocked" } },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "ob1-liens-haut-bas",
                            {
                              attrs: {
                                "button-id": "blocked-link",
                                "collapsed-block-id": "blocked-offer",
                                "button-label":
                                  _vm.pageDTO.blockedOfferConditionsDTO.title,
                                "is-mini": false,
                              },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "text-mw d-flex flex-column" },
                                [
                                  _c("span", { staticClass: "mb-1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.pageDTO.blockedOfferConditionsDTO
                                            .line1
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.pageDTO.blockedOfferConditionsDTO
                                            .line2
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "mt-1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.pageDTO.blockedOfferConditionsDTO
                                            .line3
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _c("div", [
              _vm.currentOffer.blocked
                ? _c(
                    "div",
                    { staticClass: "row", attrs: { id: "messageBlocked" } },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.pageDTO.blockedOfferConditionsDTO.title)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-mw d-flex flex-column" }, [
                          _c("span", { staticClass: "my-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.pageDTO.blockedOfferConditionsDTO.line1
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.pageDTO.blockedOfferConditionsDTO.line2
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "mt-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.pageDTO.blockedOfferConditionsDTO.line3
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "content-visibility-auto bg-gray2" },
          [
            _vm.brandAnimationCds
              ? _c("brand-animation-section-cds", {
                  staticClass: "pt-2 container-fluid",
                  attrs: { "brand-animation": _vm.brandAnimationCds },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-1" },
          [
            _c("ob1-liens", {
              attrs: {
                href: _vm.pageDTO.fisLink.link,
                text: _vm.pageDTO.fisLink.text,
                "with-arrow": true,
                target: "_blank",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.faq
          ? _c(
              "div",
              [
                _c("Faq", {
                  staticClass: "mt-2",
                  attrs: {
                    title: _vm.pageDTO.faq.title,
                    "question-list": _vm.pageDTO.faq.questionList,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "bg-gray2 mt-1" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "div",
          { staticClass: "mt-4 mt-lg-2 pt-2" },
          [_c("free-hands", { attrs: { text: _vm.pageDTO.handsFreeLabel } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pt-xl-2 pb-3" },
          [
            _c(
              "ob1-legal-notice",
              {
                staticClass: "py-2",
                attrs: {
                  "button-id": _vm.pageDTO.legalMentions.title.headerId,
                  "button-label": _vm.pageDTO.legalMentions.title.title,
                  "collapsed-block-id": _vm.pageDTO.legalMentions.title.textId,
                },
              },
              _vm._l(
                _vm.pageDTO.legalMentions.mentions,
                function (mention, index) {
                  return _c("div", { key: "mention-" + index }, [
                    _c("p", { staticClass: "small" }, [
                      mention.title
                        ? _c("strong", [_vm._v(_vm._s(mention.title))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(mention.text) },
                      }),
                    ]),
                  ])
                }
              ),
              0
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bg-dark" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("orange-commitments", {
            staticClass: "d-webview-none",
            attrs: { commitments: _vm.pageDTO.commitments },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.pageDTO.filArianeDTO
      ? _c("div", { staticClass: "bg-dark d-webview-none" }, [
          _c(
            "div",
            { staticClass: "container-fluid py-1" },
            [
              _c("ob1-breadcrumb", {
                attrs: {
                  items: _vm.pageDTO.filArianeDTO.items,
                  "is-inverse": "",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }